import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        uibModalInstance: '=',
        occurrence: '='
    },
    template: `
        <div class="modal-header" id="modal-header">
            <button type="button" class="close" ng-click="vm.uibModalInstance.dismiss()"></button>
            <h2>{{ 'course.Add files' | translate }}</h2>
        </div>
        <div class="modal-body">
            <div class="form">
                <form-row error="vm.form.errors.file">
                    <label class="label pt0">{{ 'course.File' | translate }}</label>
                    <div class="items">
                        <input ng-model="vm.form.model.file" ngf-select="vm.setFile()" type="file" multiple/>
                        <form-row-error></form-row-error>
                    </div>
                </form-row>
            </div>
        </div>
        <div class="modal-footer">
            <ul class="actions01">
                <li class="primary">
                    <button
                        class="btn main"
                        type="button"
                        ng-click="vm.add()"
                        ng-disabled="vm.loading"
                        ng-class="{'loading': vm.loading}"
                    >{{ 'general.Add' | translate }}</button>
                </li>
                <li>
                    <button
                        class="btn discrete"
                        type="button"
                        ng-click="vm.uibModalInstance.dismiss()"
                    >{{ 'general.Cancel' | translate }}</button>
                </li>
            </ul>
        </div>
    `
})
export default class {
    constructor ($translate, lodash, ModalService,
                 OccurrenceResource, FormFactory, Upload, ResponseService, MomentService, toastr) {
        this.$translate = $translate;
        this.lodash = lodash;
        this.ModalService = ModalService;
        this.OccurrenceResource = OccurrenceResource;
        this.ResponseService = ResponseService;
        this.FormFactory = FormFactory;
        this.MomentService = MomentService;
        this.Upload = Upload;
        this.toastr = toastr;

        this.form = FormFactory.create(
            this.occurrence,
            model => model.$update({ id: model.id, expand: 'courseOccurrenceParticipants,courseVersion,courseOccurrenceLanguages,courseOccurrenceManagers,files,sites' })
        );
        this.form.model.file = [];
        this.loading = false;
    }

    setFile () {
        this.form.model.directManagerIds = this.form.model.courseOccurrenceManagers.map(val => val.userId);
        if (this.form.model.displayUntil && !this.isDateValid(this.form.model.displayUntil)) {
            this.form.model.displayUntil = this.MomentService.formatTimeStamp(this.form.model.displayUntil, 'YYYY-MM-DD HH:mm:ss', true);
        }
        if (this.form.model.publishDate && !this.isDateValid(this.form.model.publishDate)) {
            this.form.model.publishDate = this.MomentService.formatTimeStamp(this.form.model.publishDate, 'YYYY-MM-DD HH:mm:ss', true);
        }
    }

    /**
     * Checks whether date is in the correct format of YYY-MM-DD HH:mm:ss
     *
     * @param {string} date
     */
    isDateValid (date) {
        const regex = /[0-9]{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1]) (2[0-3]|[01][0-9]):[0-5][0-9]:[0-5][0-9]/;
        return String(date).match(regex);
    }

    add () {
        this.doSave();
    }

    doSave () {
        let uploadUrl = `${SEED_CORE.ENV.API_URL}course/occurrence`;
        let method = 'POST';

        this.loading = true;

        if (this.form.model.id) {
            delete this.form.model.$promise;
            delete this.form.model.$resolved;
            uploadUrl += `/${this.form.model.id}`;
            method = 'PUT';
        }
        uploadUrl += '?expand=courseOccurrenceParticipants,courseVersion,courseOccurrenceLanguages,courseOccurrenceManagers,files,sites';
        return this.Upload.upload({
            url: uploadUrl,
            method,
            data: this.form.model
        }).then(() => {
            this.loading = false;
            this.uibModalInstance.close();
        }).catch((response) => {
            this.loading = false;
            this.form.errors = this.ResponseService.parseErrors(response);
            if (Array.isArray(response.data) && response.data[0].message) {
                this.toastr.error(response.data[0].message);
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/courses/occurrence/files/add/index.js